angular.module('lf.desktop')

.factory('scrolls', function () {
  
  var scrolls = {};

  return {
    register: angular.noop,
    get: angular.noop,
    unregister: angular.noop,
    scrollTop: function (time) {
      time = typeof time == 'number' ? time : 500;
      $('html').velocity('scroll', { offset: 0, duration: time });
    }
  }

});
